// In Private Mode on iOS, setting items in the storage fails.
// We wrap it to make sure we can make it at least not crash.
let storage = localStorage
let _supported = true
try {
  storage.setItem('supported', 'true')
  storage.removeItem('supported')
} catch (err) {
  const map = new Map()
  _supported = false
  storage = {
    getItem: (item) => {
      const r = map.get(item)
      return r === undefined ? null : r
    },
    setItem: (item, value) => map.set(item, (value === undefined || value === null) ? value : value.toString()),
    removeItem: (item) => map.delete(item)
  }
}

export const storageSupported = () => _supported
export default storage



// WEBPACK FOOTER //
// ./src/client/misc/localStorage.js